export default {
    data() {
        return {
            selectedAppDate: this.selectedFittingDate ? this.selectedFittingDate : '',
            selectedAppTime: this.selectedFittingTime ? this.selectedFittingTime : '',
            appTimes: null
        }
    },
    mounted() {
        this.setAppDate();
        this.setAppTime();
        this.setFittingTimes();

        //This is needed incase the customer comes from from the fitted nationally route, then chose a tyre that wasn't available for the fitting appointment selected.
        //So we check if the chosen date is still in the fitters available fitting days, otherwise we choose the first option.
        if(!(this.selectedAppDate in this.fitter.fitting_days)) {
            this.selectedAppDate = Object.keys(this.fitter.fitting_days)[0];
        }

        //We check if the chosen time is still in the fitters available fitting times, otherwise we set it as empty to trigger the validation, forcing them to choose a new time.
        // Check appTimes first (handles nested structure), then fall back to fitter.fitting_times
        const timesToCheck = this.appTimes && Object.keys(this.appTimes).length > 0 
            ? this.appTimes 
            : (this.fitter.fitting_times || {})
        if(this.selectedAppTime && !(this.selectedAppTime in timesToCheck)) {
            this.selectedAppTime = Object.keys(timesToCheck)[0] || '';
        }
    },
    watch: {
        'fitter.fitting_days': {
            handler(newDays, oldDays) {
                // Only apply this logic if batteryRoute is true and clickCollect is false
                if (this.batteryRoute && this.clickCollect === false) {
                    // If fitting_days changed and current selected date is not in the new list, update to first available
                    if (newDays && Object.keys(newDays).length > 0) {
                        if (!(this.selectedAppDate in newDays)) {
                            this.selectedAppDate = Object.keys(newDays)[0];
                            // Update fitting times for the new date
                            this.setFittingTimes();
                            this.setAppTime();
                        }
                    }
                }
            },
            deep: true
        },
        selectedAppDate: {
            handler(newDate) {
                // Only apply this logic if batteryRoute is true and clickCollect is false
                if (this.batteryRoute && this.clickCollect === false) {
                    // When date changes, update fitting times
                    if (newDate) {
                        this.setFittingTimes();
                        this.setAppTime();
                    }
                }
            }
        }
    },
    methods: {
        setFittingTimes() {
            if(this.fitter.cal_account_number == 'CALTOTD' && this.selectedAppDate == '') {
                this.appTimes = [];
                return;
            }

            if(this.fittingTimes) {
                this.appTimes = this.fittingTimes;
            }
            else {
                // Check if fitting_times is nested by date
                if (this.fitter.fitting_times && typeof this.fitter.fitting_times === 'object' && !Array.isArray(this.fitter.fitting_times)) {
                    // Check if it's nested (has date keys)
                    const firstKey = Object.keys(this.fitter.fitting_times)[0];
                    if (firstKey && firstKey.match(/^\d{4}-\d{2}-\d{2}$/)) {
                        // It's nested by date, get times for selected date
                        if (this.selectedAppDate && this.fitter.fitting_times[this.selectedAppDate]) {
                            this.appTimes = this.fitter.fitting_times[this.selectedAppDate];
                        } else {
                            this.appTimes = {};
                        }
                    } else {
                        // It's flat (all times for all dates)
                        this.appTimes = this.fitter.fitting_times;
                    }
                } else {
                    this.appTimes = this.fitter.fitting_times || {};
                }
            }
        },
        setAppDate() {
            if(this.selectedFittingDate) {
                this.selectedAppDate = this.selectedFittingDate;
            }
            else if(this.fitter.cal_account_number != 'CALTOTD') {
                this.selectedAppDate = Object.keys(this.fitter.fitting_days)[0];
            }
            else {
                // this.selectedAppDate = '';
                this.selectedAppDate = Object.keys(this.fitter.fitting_days)[0];
            }
        },
        setAppTime() {
            var vm = this;
            if(this.selectedFittingTime) {
                var selectedStartTime = this.selectedFittingTime;
                var selectedEndTime = this.selectedFittingEndTime;
                var selected = '';

                _.forEach(vm.fittingTimes, function(value, key) {
                    var splitTime = _split(key, '|');

                    if(vm.fitter.cal_account_number == 'CALTOTD') {
                        if((typeof(selectedEndTime) != 'undefined' && selectedStartTime == splitTime[0] && selectedEndTime == splitTime[1])) {
                            selected = key;
                            return false;
                        }
                        if(selectedStartTime == splitTime[0] && typeof(selectedEndTime) == 'undefined' ) {
                            selected = key;
                            return false;
                        }

                        selected = '';
                    }
                    else {
                        if(selectedStartTime == splitTime[0]) {
                            selected = key;
                            return false;
                        }
                    }
                });

                vm.selectedAppTime = selected;

                if(selected == '' && this.$parent.$parent.$parent.view == 'fittedNationally') {
                    vm.selectedAppTime = this.selectedFittingTime;
                }
            }
            else if(vm.selectedAppDate == '') {
                vm.selectedAppTime = '';
            }
            else {
                //If basket has been regenerated, above selectedFittingTime is null, so it skips below checks.
                //so adding this logic into else aswell
                if(vm.fitter.cal_account_number == 'CALTOTD') {
                    
                    _.forEach(vm.fittingTimes, function(value, key) {
                        var splitTime = _split(key, '|');
                        selected = '';
                        
                        if((typeof(selectedEndTime) != 'undefined' && selectedStartTime == splitTime[0] && selectedEndTime == splitTime[1])) {
                            selected = key;
                            return false;
                        }
                        if(selectedStartTime == splitTime[0] && typeof(selectedEndTime) == 'undefined' ) {
                            selected = key;
                            return false;
                        }
                    });

                    vm.selectedAppTime = selected;
                }
                else {
                    // Use appTimes if available (handles nested structure), otherwise fall back to fitter.fitting_times
                    const timesToUse = vm.appTimes && Object.keys(vm.appTimes).length > 0 
                        ? vm.appTimes 
                        : (vm.fitter.fitting_times || {})
                    vm.selectedAppTime = Object.keys(timesToUse)[0] || '';
                }
            }
        },
        //This function is only here because node_modules of tyre platform doesn't have required packages to use async/await
        //will be moved to mixin once this issue is resolved
        async reloadFittingTimes(event) {
            // Native <select> change can fire before v-model/vee-validate sync on some engines (e.g. Firefox).
            // event.target.value is always the new selection at change time.
            if (event?.target?.tagName === 'SELECT') {
                this.selectedAppDate = event.target.value;
            }

            this.emitter.emit('isLoading', true);

            if(this.$parent.$parent.view == 'fittedNationally') {
                this.$parent.$parent.appDate = this.selectedAppDate;
            }

            this.appTimes = [];

            //Update basket fitting date
            if(this.updateFittingDate == true) {
                var updateFittingDate = await axios.post('/ajax/update_basket_app_date/' + this.selectedAppDate);
                this.emitter.emit('refreshBasket');
            }

            var response = await axios.post('/ajax/update_times/' + this.fitter.account_number + '/' + this.selectedAppDate);

            this.appTimes = response.data;

            if(typeof(this.appTimes != 'undefined')) {
                this.selectedAppTime = Object.keys(this.appTimes)[0];
            }
            
            if(typeof(this.selectedAppTime != 'undefined') && this.fitter.mobile == 0 && this.fitter.cal_account_number != 'CALTOTD') {
                axios('/ajax/update_basket_app_time/' + this.selectedAppTime);
            }

            //Enables CALTOTD submit button
            if(this.fitter.cal_account_number == 'CALTOTD' && (this.selectedAppTime != 'invalid')) {
                this.$parent.$parent.dateSelected = true;
            }
            this.emitter.emit('isLoading', false);
        },
        async updateBasketFittingTime(event) {
            if (event?.target?.tagName === 'SELECT') {
                this.selectedAppTime = event.target.value;
            }

            this.emitter.emit('isLoading', true);

            if(this.$parent.$parent.view == 'fittedNationally') {
                this.$parent.$parent.appTime = this.selectedAppTime;
            }

            await axios('/ajax/update_basket_app_time/' + this.selectedAppTime)
            .then(response => {
                console.log('fitting time updated to: ' + this.selectedAppTime);
            })
            .catch(error => {
                console.error("There was an error!", error);
            });

            this.emitter.emit('refreshBasket');
            this.emitter.emit('isLoading', false);
        }
    }
};